export const enum TrackingEnum {
    Asset = "Asset",
    AssetDetail = "AssetDetail",
    ANumber = "ANumber",
    ANumberDetail = "ANumberDetail",
    ANumberGroup = "ANumberGroup",
    ANumberGroupDetail = "ANumberGroupDetail",
    ANumberAssign = "ANumberAssign",
    BatchPush = "BatchPush",
    ContentProvider = "ContentProvider",
    ContentProviderDetail = "ContentProviderDetail",
    DemoPush = "DemoPush",
    Inform = "Inform",
    Engage = "Engage",
    MassUpload = "MassUpload",
    Program = "ProgramContent",
    ProgramContentType = "ProgramContentType",
    ScopedUser = "ScopedUser",
    ScopedUserDetail = "ScopedUserDetail",
    ServiceProvider = "ServiceProvider",
    ServiceProviderDetail = "ServiceProviderDetail",
    User = "User",
    UserDetail = "UserDetail"
}